<template>
    <div class="loading-box match-detail-box">
        <div class="display-flex-evenly gap-10px white-box pt-1rem">
            <div class="flex-column-space-between">
                <div class="square animation square-team"></div>
                <div class="pill animation w-70px mt-4px"></div>
                <div class="mt-11px display-flex-center gap-4px">
                    <div class="circle animation circle-small-text" v-for="i in 6"></div>
                </div>
            </div>
            <div class="w-117px flex-column-space-between flex-shrink">
                <div class="pill animation pill-title w-70"></div>
                <div class="pill animation pill-small-text w-50 mt-11px"></div>
            </div>
            <div class="flex-column-space-between">
                <div class="square square-team"></div>
                <div class="pill animation w-70px mt-4px"></div>
                <div class="mt-11px display-flex-center gap-4px">
                    <div class="circle animation circle-small-text" v-for="i in 6"></div>
                </div>
            </div>
        </div>

        <div class="display-flex-center gap-8px pt-1rem pb-2063px relative white-box">
            <div class="pill animation pill-4 w-40px mx-8px">
                <div class="pill animation pill-line w-40px absolute-line"></div>
            </div>
            <div class="pill animation pill-4 w-18px mx-8px"></div>
            <div class="pill animation pill-4 w-56px mx-8px"></div>
            <div class="pill animation pill-4 w-26px mx-8px"></div>
        </div>

        <div v-if="page === 'FOOTBALL_LATEST'">
            <div class="mt-1rem px-8px">
                <div class="white-box estimated-box w-100 radius-8px pa-16px">
                    <div class="display-flex-center mb-15rem">
                        <div class="pill animation pill-title  w-70"></div>
                    </div>
                    <div class="display-flex-align-center gap-16px mb-1rem h-32px">
                        <div class="square animation square-small flex-shrink"></div>
                        <div class="pill animation pill-content w-100"></div>
                    </div>
                    <div class="display-flex-align-center gap-16px mb-1rem h-32px">
                        <div class="pill animation square-small flex-shrink h-1050px"></div>
                        <div class="pill animation pill-content w-100"></div>
                    </div>
                    <div class="display-flex-align-center gap-16px mb-1rem h-32px">
                        <div class="square animation square-small flex-shrink"></div>
                        <div class="pill animation pill-content w-100"></div>
                    </div>
                    
                </div>
            </div>
    
            <div class="mt-1rem px-8px">
                <div class="white-box w-100 radius-8px pa-16px">
                    <div class="display-flex-center mb-2rem">
                        <div class="pill animation pill-title  w-70"></div>
                    </div>
                    <div class="rect h-40px"></div>
                </div>
            </div>
    
            <div class="mt-1rem px-8px">
                <div class="white-box estimated-box w-100 radius-8px pa-16px">
                    <div class="display-flex-center mb-15rem">
                        <div class="pill animation pill-title  w-70"></div>
                    </div>
                    <div class="display-flex-align-center gap-16px mb-1rem">
                        <div class="circle animation square-small flex-shrink"></div>
                        <div class="pill animation pill-content w-87px"></div>
                    </div>
                    <div class="display-flex-align-center gap-16px mb-1rem">
                        <div class="circle animation square-small flex-shrink"></div>
                        <div class="pill animation pill-content w-70px"></div>
                    </div>
                    <div class="display-flex-align-center gap-16px mb-1rem">
                        <div class="circle animation square-small flex-shrink"></div>
                        <div class="pill animation pill-content w-87px"></div>
                    </div>
                    
                </div>
            </div>

        </div>

        <div v-if="page === 'FOOTBALL_STATS'">
            <div class="mt-1rem px-8px">
                <div class="white-box w-100 radius-8px pa-16px">
                    <div class="display-flex-center mb-15rem">
                        <div class="pill animation pill-title  w-50px"></div>
                    </div>

                    <div class="display-flex-sb mb-1rem">
                        <div class="pill animation w-35px h-14px"></div>
                        <div class="pill animation w-42px h-14px"></div>
                        <div class="pill animation w-35px h-14px"></div>
                    </div>

                    <div class="display-flex-sb mb-1rem">
                        <div class="pill animation w-35px h-14px"></div>
                        <div class="pill animation w-87px h-14px"></div>
                        <div class="pill animation w-42px h-14px"></div>
                        <div class="pill animation w-87px h-14px"></div>
                        <div class="pill animation w-35px h-14px"></div>
                    </div>

                    <div class="display-flex-center line-bb-dot-cbdd pb-1rem">
                        <div class="pill animation w-42px h-14px"></div>
                    </div>

                    <div class="display-flex-sb mb-1rem pt-1rem line-bb-dot-cbdd pb-1rem">
                        <div class="pill animation w-35px h-14px"></div>
                        <div class="pill animation w-70px h-14px"></div>
                        <div class="pill animation w-35px h-14px"></div>
                    </div>
                    
                    <div class="display-flex-sb mb-15rem">
                        <div class="pill animation w-35px h-14px"></div>
                        <div class="pill animation w-70px h-14px"></div>
                        <div class="pill animation w-35px h-14px"></div>
                    </div>
                    
                </div>

            </div>
            
            <div class="mt-1rem px-8px">
                <div class="white-box w-100 radius-8px pa-16px mt-1rem">
                    <div class="display-flex-center mb-15rem">
                        <div class="pill animation pill-title  w-70"></div>
                    </div>
                    
                    <div v-for="(i,index) in statsList" :key="index">
                        <div class="display-flex-sb mb-1rem">
                            <div class="pill animation w-35px h-14px">
                            </div>
                            <div class="pill animation w-70px h-14px" :style="{
                                width: i.width
                            }"></div>
                            <div class="pill animation w-35px h-14px"></div>
                        </div>
                        <div class="display-flex-center mb-1rem gap-8px">
                            <div class="pill animation w-50 h-14px"></div>
                            <div class="pill animation w-50 h-14px"></div>

                        </div>
                    </div>
                </div>
                
            </div>
        </div>

        <div v-if="page === 'FOOTBALL_LINEUPS'">
            <div class="mt-1rem px-8px">
                <div class="white-box w-100 radius-8px pa-16px mt-1rem">
                    <div class="display-flex-center mb-1rem gap-8px">
                        <div class="pill animation w-50 h-34px line-b-solid-cbddh display-flex-center gap-8px">
                            <div class="circle circle-medium white-box"></div>
                            <div class="pill pill-text white-box"></div>
                        </div>
                        <div class="pill w-50 h-34px line-b-solid-cbddh white-box display-flex-center gap-8px">
                            <div class="circle animation circle-medium"></div>
                            <div class="pill animation pill-text"></div>
                        </div>
                    </div>

                    <div class="pb-1rem line-bb-dot-cbdd">
                        <div class="square animation w-100 h-327px"></div>
                    </div>

                    <div class="line-bb-dot-cbdd pa-16px">
                        <div class="display-flex-center mb-05rem">
                            <div class="pill animation pill-content  w-70px"></div>
                        </div>
                        <div class="display-flex-center">
                            <div class="pill animation pill-content  w-100px"></div>
                        </div>
                    </div>

                    <div class="line-bb-dot-cbdd pa-16px">
                        <div class="display-flex-center mb-05rem">
                            <div class="pill animation pill-content  w-70px"></div>
                        </div>
                        
                        <div class="display-flex-sb">
                            <div class="w-100 radius-8px py-16px">
                                <div class="display-flex-align-center gap-16px mb-1rem h-32px">
                                    <div class="pill animation w-11px h-18px flex-shrink"></div>
                                    <div class="circle animation circle-small "></div>
                                    <div class="pill animation pill-content w-127px"></div>
                                </div>
                                <div class="display-flex-align-center gap-16px mb-1rem h-32px">
                                    <div class="pill animation w-11px h-18px flex-shrink"></div>
                                    <div class="circle animation circle-small "></div>
                                    <div class="pill animation pill-content w-138px"></div>
                                </div>
                            </div>
                            <div class="pill animation w-15px h-1225px flex-shrink"></div>
                        </div>
                    </div>


                </div>
                
            </div>
        </div>

        <div v-if="page === 'FOOTBALL_FEED'">
            <div class="mt-1rem px-8px">
                <div class="white-box w-100 radius-8px pa-16px mt-1rem">
                    <div v-for="(i,index) in feedList" 
                        :key="index"
                        class="mb-05rem pb-8px line-bb-dot-cbdd">
                        <div class="display-flex-sb">
                            <div class="pill w-48px"></div>
                            <div class="pill w-160px" :style="{width: i.width}"></div>
                            <div class="pill w-53px" :style="{width: i.width2}"></div>
                            <div class="pill pill-column"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'LoadingHomeMatchCard',
        data() {
            return {
                feedList: [],
                statsList: [],
                feedLength: 20,
                statsLength: 13,
            }
        },
        props: {
            type: String,
            page: String
        },
        mounted() {
            this.InitListLength()
        }, 
        methods: {
            InitListLength() {
                const feedWidths = [160,199,173,151,194,138];
                const feedWidths2 = [53,26,33,46,69,22]
                this.feedList = Array.from({ length: this.feedLength }, (_, i) => ({
                    id: i + 1,
                    width: `${feedWidths[Math.floor(Math.random() * feedWidths.length)]}px`,
                    width2: `${feedWidths2[Math.floor(Math.random() * feedWidths2.length)]}px`
                }));

                const statsWidths = [77,48,81,107,37,43,41]
                this.statsList = Array.from({ length: this.statsLength }, (_, i) => ({
                    id: i + 1,
                    width: `${statsWidths[Math.floor(Math.random() * statsWidths.length)]}px`
                }));

                
            } 
        }
    }
</script>

<style scoped src="../../assets/css/loading/index.css"></style>

<style scoped>
.gap-4px {
    gap: 4px;
}
.gap-10px {
    gap: 10px;
}
.gap-16px {
    gap: 16px;
}
.square-team {
    width: 70px;
    height: 70px;
}
.display-flex-evenly {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
}
.w-122px {
    width: 122px;
}
.pb-2063px {
    padding-bottom: 20.63px;
}
.absolute-line {
    position: absolute;
    bottom: 0;
}
.match-detail-box {
    padding: 0;
    background-color: var(--color-background-default-default);
}
.match-detail-box .white-box {
    background-color: var(--color-background-default-secondary);
}
.estimated-box {
    height: 205px;
}
</style>